module.exports = __webpack_public_path__ + "img/7.649de333.png";